import { RefreshCw } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

export const AuthShell = ({ title, description, children, testId }) => (
  <div className="min-h-screen flex items-center justify-center px-4 py-10 bg-slate-950" data-testid={testId}>
    <div className="w-full max-w-md">
      <div className="flex items-center gap-3 mb-8 justify-center">
        <div className="w-10 h-10 rounded-xl bg-blue-500 flex items-center justify-center">
          <RefreshCw className="w-6 h-6 text-white" />
        </div>
        <span className="text-xl font-bold font-heading text-white">SyncPoint</span>
      </div>
      <Card className="border-slate-800 bg-slate-900/50">
        <CardHeader className="space-y-1 pb-6">
          <CardTitle className="text-2xl font-heading font-bold text-white">{title}</CardTitle>
          <CardDescription className="text-slate-400">{description}</CardDescription>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  </div>
);
